export default "__VITE_ASSET__$pS5qXiT__"